import PropTypes from 'prop-types';

import { CommonPaymentElementPropTypes } from '../../propTypes';

export const SlotPropType = {
  position: PropTypes.oneOf(['top', 'bottom']),
  slot: PropTypes.object,
};

export const PaymentElementThemePropTypes = {
  globalStyles: PropTypes.object,
  colorMode: PropTypes.oneOf(['light', 'dark']),
  components: PropTypes.object,
  foundations: PropTypes.object,
};

export const PaymentElementPropTypes = {
  ...CommonPaymentElementPropTypes,
  apiKey: PropTypes.string.isRequired,
  propertyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  theme: PropTypes.shape(PaymentElementThemePropTypes).isRequired,
  amount: PropTypes.number,
  capture: PropTypes.oneOf(['auto', 'manual']),
  currency: PropTypes.string,
  labels: PropTypes.object,
  slots: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.shape(SlotPropType),
    PropTypes.arrayOf((PropTypes.shape(SlotPropType))),
  ])),
  components: PropTypes.object,
  allowedPaymentMethods: PropTypes.arrayOf(PropTypes.string),
};
